// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recommended-items__title{text-align:center}.recommended-items__load-more{text-align:center;margin-bottom:var(--spacer-3)}.recommended-items .row{justify-content:space-around}.recommended-items .product-card{margin-bottom:var(--spacer-2)}.recommended-items .product-card__prices{justify-content:center}.recommended-items .product-card__buy{opacity:1;position:static;display:block}", ""]);
// Exports
module.exports = exports;
